  <app-header></app-header>
  <app-sidenav></app-sidenav>
  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>

  <div id="content" class="app-content" role="main">
    <div class="app-content-body">
      <div class="main">
        <h4 class="hscore">Upload Documents</h4>
      </div>
<form [formGroup]="documentForm" (ngSubmit)="addDocument()">

      <div class="col-sm-12">
        <div class="panel pd">
          <div class="row">
            <!-- Financial Year -->
            <div class="col-sm-6">
              <p>Financial Year <span class="text-danger">*</span></p>
              <select formControlName="financialYear" class="form-control">
                <option value="">Select</option>
                <option *ngFor="let year of finYears" [value]="year._id">{{ year.financialYear }}</option>
              </select>
              <div *ngIf="documentForm.get('financialYear')?.invalid && documentForm.get('financialYear')?.touched" class="text-danger">
                Financial Year is required
              </div>
            </div>

            <!-- User Type -->
            <div class="col-sm-6">
              <p>User Type <span class="text-danger">*</span></p>
              <select formControlName="userType" class="form-control">
                <option value="">Select</option>
                <option value="Applicant">Applicant</option>
                <option value="Assessor">Assessor</option>
              </select>
              <div *ngIf="documentForm.get('userType')?.invalid && documentForm.get('userType')?.touched" class="text-danger">
                User Type is required
              </div>
            </div>

            <!-- File Upload -->
            <div class="col-sm-12 mt-3">
              <p>Upload Document <span class="text-danger">*</span></p>
              <input type="file" (change)="uploadDocument($event)" class="form-control" />
              <div *ngIf="documentForm.get('document')?.invalid && documentForm.get('document')?.touched" class="text-danger">
                Document is required
              </div>
            </div>
          </div>
          <div style="display: flex;justify-content: end;margin-top: 10px;">
            <button type="submit" class="AddBtn mt-3">Add</button>
          </div>
        </div>
      </div>
</form>

  <div class="col-md-12 m-3">
          <div class="card p-3">
            <table class="table table-striper">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Financial Year</th>
                  <th>User Type</th>
                  <th>File Name</th>
                  <th>Document</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of documentList; index as i">
                  <td>{{i+1}}</td>
                  <td>{{doc?.financialYear}}</td>
                  <td>{{doc?.userType}}</td>
                  <td>{{doc?.fileName}}</td>
                  <td>{{doc?.document}}</td>
                  <td>
                    <div class="dropdown">
                      <button class="btn btn-default dropdown-toggle btn-cls" type="button" id="menu1"
                        data-toggle="dropdown"><span class="app-id"> <i class="fa fa-cog"
                            aria-hidden="true"></i>&nbsp;</span>
                        <span class="caret"></span></button>
                      <ul class="dropdown-menu" role="menu" aria-labelledby="menu1">
                        <li role="presentation" (click)="openFile(doc?.document)"><a role="menuitem" data-toggle="modal" data-target="#showWinners"
                            aria-hidden="true"  tabindex="-1"> View </a></li>
                        <li role="presentation" (click)="deleteDocument(doc?._id)"><a role="menuitem"  tabindex="-1">
                           Delete
                          </a></li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

    </div>
  </div>
